import React from "react";
import styled from "styled-components";
import { Configuration } from "../context/ConfigurationContext";
import ConnectionTest from "./ConnectionTest";
import PitchRenderer from "./PitchRenderer";
import { Wrapper, WrapperProps } from "./Wrapper";

type ContainerProps = WrapperProps & {
  height: number;
  width: number;
};

const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${(props) => props.width + "px"};
  height: ${(props) => props.height + "px"};
  margin-left: auto;
  margin-right: auto;
`;

export type ConfigurationRenderProps = {
  config: Configuration;
  thinConfig?: Configuration;
  configMode?: boolean;
};

const StrikeZoneRender: React.FC<React.PropsWithChildren<ConfigurationRenderProps>> = ({
  config,
  thinConfig,
  configMode = false,
}) => {
  return (
    <Wrapper backgroundColor={config.palette.background} configMode={configMode}>
      <ConnectionTest config={config} thinConfig={thinConfig}>
        <Container
          backgroundColor={config.palette.background}
          width={config.scaling.width}
          height={config.scaling.height}
          configMode={configMode}
        >
          <PitchRenderer config={config} thinConfig={thinConfig} />
        </Container>
      </ConnectionTest>
    </Wrapper>
  );
};

export default StrikeZoneRender;
